import styled from "styled-components";

import { FlexColumn } from "@similarweb/ui-components";

import QuotaLeftLink from "../QuotaLeftLink";

export const StyledSelectionDropdownQuotaFooterContainer = styled(FlexColumn)`
    justify-content: space-between;
`;

export const LowCreditsBannerWrapper = styled(FlexColumn)`
    margin-bottom: 8px;
`;

export const StyledQuotaLeftLink = styled(QuotaLeftLink)`
    justify-content: space-between;
    margin: 20px 12px;
`;
